import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class ImageUploadConfigModel extends BaseAPIModel {
    static PROCESS = null;

    fields() {
        return {
            uuid: { primaryKey: true }
        };
    }

    /**
     * POSTs to AWS S3 to upload image once the config is set
     */
    uploadFile(file) {
        // Sadly, fields is a method of BaseAPIModel, we must retrieve
        // the actual value from our underlying JSON object
        const {
            upload_config: { url, fields }
        } = this;

        if (!url || !fields) {
            throw new Error(`[Model][UploadConfig][upload] You should get a config first by calling .get or .getAll`);
        }

        let data = new FormData();

        Object.entries(fields).map(([key, value]) => data.append(key, value));

        // APparently AWS S3 does not like having 'key' after 'file'
        data.append('file', file);

        return fetch(url, {
            method: 'POST',
            headers: {
                contentType: 'multipart/form-data'
            },
            body: data
        }).then(() => {
            // 204 no content
            this.path = fields.key;
            if (this.constructor.PROCESS) {
                this.source = fields.key;
                this.file = file;
                this.process = this.constructor.PROCESS;
            }
            return this;
        });
    }

    uploadConfig({ organizationId, eventId = null }, queryParams) {
        const url = `${this.constructor.listUrl({ organizationId, eventId })}/upload_config`;
        return fetcher.get(url, { query: queryParams }).then(({ response }) => {
            this.upload_config = response;
            return this;
        });
    }

    getUploadDate({ url }) {
        return fetcher.get(url).then(({ headers }) => {
            return headers.get('last-modified');
        });
    }

    getUploadFileHeaders({ url }) {
        return fetcher.get(url).then(({ headers }) => {
            return headers;
        });
    }

    static toAPI() {
        const { path } = this;
        return { path };
    }

    static listUrl({ organizationId, eventId = null }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][UploadConfig][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}${eventId ? `/events/${eventId}` : ''}/images`;
    }
}
